<template src='./list.pug' lang='pug'></template>

<script>
import PageTitle from '../../../layout/pageTitle/PageTitle'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import LoadingPlaceholder from '../../../loading/LoadingPlaceholder'
import VueDragTree from '../../../registration/conciliationPlan/TreeViewPlans'
import ConfirmModal from '../../../modals/confirmModal/ConfirmModal'
import customSorter from '../../../../utils/customSorter.js'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import { generateLoadingRows } from '../../../../utils/grid-load-transition.js'
import PATHS from '../../../../router/routesMap.js'

export default {
  name: 'ConciliationPlanList',

  components: {
    PageTitle,
    ButtonPrimary,
    LoadingPlaceholder,
    VueDragTree,
    ConfirmModal
  },

  data () {
    return {
      isLoadingData: true,
      treeViewButtonTitle: {
        config: this.$t('planoConciliacao.labels.gerenciar'),
        edit: this.$t('categoria.labels.editar'),
        create: this.$t('planoConciliacao.labels.criar'),
        expand: this.$t('categoria.labels.expandir'),
        collapse: this.$t('categoria.labels.recolher'),
        remove: this.$t('planoConciliacao.labels.remover'),
        removeBloq: this.$t('planoConciliacao.labels.removerBloqueado')
      },
      plans: generateLoadingRows(10),
      columns: ['planName', 'acoes'],
      options: {
        columnsClasses: { 'acoes': 'col-md-1', 'planName': 'col-md-11' },
        headings: {
          nomePlanoConciliacao: this.$t('planoConciliacao.labels.plano'),
          acoes: this.$t('planoConciliacao.labels.acoes')
        },
        templates: {
          nome: LoadingPlaceholder,
          acoes: LoadingPlaceholder
        },
        filterable: ['planName'],
        filterByColumn: true,
        perPageValues: [],
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: this.$t('dataTable.labels.filtrar')
        },
        sortable: ['planName'],
        sortIcon: {
          is: ''
        },
        pagination: { chunk: 5 },
        customSorting: {
          nome: function (ascending) {
            return function (a, b) {
              return customSorter.stringSorter(ascending, a, b, 'planName')
            }
          }
        }
      },
      planIdToRemove: null
    }
  },

  methods: {
    edit (conciliationPlanId) {
      trackAnalyticsEvent(this, 'edit-click', 'edit-plano-de-conciliacao', 'edit-plano-de-conciliacao')

      this.$store.dispatch('setPlanToEdit', conciliationPlanId).then((response) => {
        this.$router.push(PATHS.NEW_CONCILIATION_PLAN)
      })
    },

    newPlan () {
      this.$router.push(PATHS.NEW_CONCILIATION_PLAN)
    },

    loadPlans () {
      let url = '/conciliationPlan/listCategorized'
      this.$store.dispatch('getPlans', url).then((response) => {
        this.plans = response.data
        this.isLoadingData = false
        this.options.templates = {}
      })
    },

    removeSpecialChars (newStringComAcento) {
      let string = newStringComAcento
      let mapaAcentosHex = {
        a: /[\xE0-\xE6]/g,
        e: /[\xE8-\xEB&(?!amp;)]/g,
        i: /[\xEC-\xEF]/g,
        o: /[\xF2-\xF6]/g,
        u: /[\xF9-\xFC]/g,
        c: /\xE7/g,
        n: /\xF1/g,
        '-': /\s/g
      }

      mapaAcentosHex.forEach(letra => {
        let expressaoRegular = mapaAcentosHex[letra]
        string = string.replace(expressaoRegular, letra)
      })

      return string
    },

    // Metodo chamando nos botoes do componente TreeViewAtt
    createEditPlan (conciliationPlanId, set, isEdit) {
      if (isEdit) {
        trackAnalyticsEvent(this, 'edit-click', 'edit-plano-de-conciliacao', 'edit-plano-de-conciliacao')

        this.$store.dispatch('setPlanToEdit', conciliationPlanId).then((response) => {
          this.$router.push(PATHS.NEW_CONCILIATION_PLAN)
        })
      }
    },

    handleRemove (planIdToRemove) {
      this.planIdToRemove = planIdToRemove
      $('#confirmRemovePlan').modal('show')
    },

    removePlan () {
      trackAnalyticsEvent(this, 'remove-click', 'remove-plano-conciliacao', 'remove-plano-conciliacao')
      if (this.planIdToRemove) {
        this.$store.dispatch('removeConciliationPlan', this.planIdToRemove)
          .then((response) => {
            this.$root.$refs.notification.success('planoConciliacao.sucesso.remover')
            this.planIdToRemove = null
            $('#confirmRemovePlan').modal('hide')
            this.loadPlans()
          })
          .catch((error) => {
            this.$root.$refs.notification.error(error.message)
          })
      }
    },

    closeModalConfirm () {
      this.occurrenceReasonIdToRemove = null
      $('#confirmRemovePlan').modal('hide')
    }
  },

  created () {
    this.loadPlans()
  }
}
</script>

<style>
#plans {
  margin-top: 15px;
}

.plans-header {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  background-color: #223763;
  color: #FFF;
  height: 30px;
  padding: 5px 15px;
  font-size: 14px;
  border-radius: 12px 12px 0px 0px;
}

.plans-header-acoes-tit {
  float:right;
  width: 86px;
  text-align: right;
  padding: 0px 5px 0px 0px;
}

.plans-header-column-left {
  padding-left: 0px;
  margin-left: 0px;
  margin-right: 6px;
}

.plans-type {
  margin-left: 3px;
}

.actions {
  text-align: center;
}

.action {
  text-align: center;
  background-color: transparent !important;
  border: none !important;
  margin: 0 5px 0 5px;
}

.action:hover {
  border: none !important;
}

.action:disabled {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// List.vue?503e2ed2